import React, { useCallback, useEffect } from 'react'
import { Transition } from '@headlessui/react'
import { createPortal } from 'react-dom'

const Modal = ({ children, show = true, className = 'pt-4 px-4 pb-20 sm:p-0', childClassName = 'px-4 pt-5 pb-4 sm:p-6', onClose, ...props }) => {
  const escFunction = useCallback((event) => {
    if (onClose && event.keyCode === 27) {
      onClose()
    }
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [])

  return createPortal(
    <Transition show={show} className="fixed z-10 inset-0 overflow-y-auto">
      <div className={`flex items-end justify-center min-h-screen text-center sm:block ${className}`}>
        <Transition.Child
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className="fixed inset-0 transition-opacity"
          ariaHidden="true"
        >
          <div className="absolute inset-0 bg-gray-200 opacity-75" onClick={onClose}></div>
        </Transition.Child>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <Transition.Child
          enter="ease-out duration-200"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          className={`inline-block align-bottom bg-white rounded-sm text-left overflow-hidden shadow transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full ${childClassName}`}
          role="dialog"
          ariaModal="true"
          ariaLabeledBy="modal-headline"
        >
          { children }
        </Transition.Child>
      </div>
    </Transition>,

    document.getElementById("react_app_modal"),
  )
}

export default Modal
